import React from "react";
import Form from "../common/form";
import Joi from "joi-browser";
import TextField from "@material-ui/core/TextField";
import LinearProgress from "@material-ui/core/LinearProgress";
import Snackbar from "@material-ui/core/Snackbar";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import FormGroup from "@material-ui/core/FormGroup";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import ProfilePic from "../components/profilePic";
import firebase from "../../services/firebase";
class Profile extends Form {
  state = {
    data: {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      phoneNumber: "",
      photoURL: "",
    },
    errors: {},
    edit: false,
    profilePic: "",
    notification: false,
  };

  schema = {
    firstName: Joi.string().required().alphanum().label("First Name"),
    lastName: Joi.string().required().alphanum().label("Last Name"),
    email: Joi,
    // .string()
    // .email({ minDomainSegments: 2, tlds: { allow: ["com", "net"] } })
    // .label("Email"),
    phoneNumber: Joi,
    photoURL: Joi,
  };

  populateUser = (user) => {
    let data = {};
    data.firstName = user.displayName ? user.displayName.split(" ")[0] : "";
    data.lastName = user.displayName ? user.displayName.split(" ")[1] : "";
    data.email = user.email ? user.email : "";
    data.photoURL = user.photoURL
      ? user.photoURL
      : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png";
    data.phoneNumber = user.phoneNumber ? user.phoneNumber : "";
    this.setState({ data });
  };

  async componentDidMount() {
    await firebase.currentUser().then((val) => {
      this.populateUser(val);
    });
  }

  imageHandler = (e) => {
    let profilePic = e.target.files[0];
    const data = { ...this.state.data };
    const reader = new FileReader();
    reader.readAsDataURL(profilePic);
    reader.onload = (e) => {
      if (reader.readyState === 2) {
        data.photoURL = reader.result;
      }
      this.setState({ data, profilePic });
    };
  };

  doSubmit = async () => {
    const { data, profilePic } = this.state;
    if (profilePic) {
      await firebase.updateProfileImg(profilePic);
    }
    try {
      firebase.updataUser(`${data.firstName} ${data.lastName}`);
      this.setState({ notification: true });
      setTimeout(() => {
        window.location = "/profile";
      }, 2000);
    } catch (error) {
      alert("Unknown Problem Detected");
    }
    // window.location = "/profile";
  };

  render() {
    const { data, errors, edit, notification } = this.state;
    return (
      <div className="container">
        <section>
          <div className="row mt-5">
            <div className="col-lg-4 col-md-12">
              <section className="card rgba-white-slight profile-card mb-4 text-center profile-section">
                <ProfilePic
                  data={data}
                  edit={edit}
                  imageHandler={this.imageHandler}
                ></ProfilePic>
                <div className="card-body">
                  <h4 className="card-title">
                    <strong>{this.state.firstName}</strong>
                  </h4>
                  <h5>
                    Front End UI developer, Graphics designer at{" "}
                    <a href="#/" className="orange-text">
                      Inspire Code & Graphics
                    </a>
                  </h5>
                  <p>Rewa (M.P.), India</p>

                  <a type="button" className="btn-floating btn-small">
                    <i className="fab fa-facebook-f grey-text"></i>
                  </a>
                  <a type="button" className="btn-floating btn-small">
                    <i className="fab fa-twitter grey-text"></i>
                  </a>
                  <a type="button" className="btn-floating btn-small">
                    <i className="fab fa-linkedin-in grey-text"></i>
                  </a>

                  <p className="mt-3">
                    Some quick example text to build on the card title and make
                    up the bulk of the card's content.
                  </p>

                  <button
                    type="button"
                    className="btn btn-info btn-rounded btn-sm"
                    data-toggle="modal"
                    data-target="#modalContactUser"
                  >
                    Contact<i className="fas fa-paper-plane ml-2"></i>
                  </button>
                </div>
              </section>
            </div>
            <div className="col-lg-8 mb-4">
              <section style={{ marginTop: 100 }}>
                <div className="card rgba-white-strong card-cascade narrower">
                  <div className="view view-cascade text-center p-3 mdb-color darken-3">
                    <h5 className="mb-0 text-light font-weight-bold">
                      My Profile
                    </h5>
                  </div>
                  {/* <LinearProgress variant="determinate" value={10} /> */}

                  <div className="card-body card-body-cascade text-center">
                    <form onSubmit={this.handleSubmit}>
                      <div className="row mb-2">
                        <div className="col-md-6 mb-2">
                          <TextField
                            error={errors.firstName}
                            className=""
                            id="first-name"
                            label="First Name"
                            fullWidth
                            value={data.firstName}
                            disabled={!edit}
                            name="firstName"
                            onChange={this.handleChange}
                            variant="standard"
                            color="primary"
                            helperText={errors.firstName}
                          ></TextField>
                        </div>
                        <div className="col-md-6 mb-2">
                          <TextField
                            error={errors.lastName}
                            className=""
                            id="last-name"
                            label="Last Name"
                            fullWidth
                            value={data.lastName}
                            disabled={!edit}
                            name="lastName"
                            onChange={this.handleChange}
                            variant="standard"
                            color="primary"
                            helperText={errors.lastName}
                          ></TextField>
                        </div>
                      </div>
                      <div className="row mb-2">
                        <div className="col-md-6 mb-2">
                          <TextField
                            error={errors.email}
                            className=""
                            id="email"
                            label="Email id"
                            type="email"
                            fullWidth
                            name="email"
                            value={data.email}
                            disabled
                            onChange={this.handleChange}
                            variant="standard"
                            color="primary"
                            helperText={errors.email}
                          ></TextField>
                        </div>
                        <div className="col-md-6 mb-2">
                          <TextField
                            error={errors.phoneNumber}
                            className=""
                            id="contact-no"
                            label="Contact No"
                            fullWidth
                            value={data.phoneNumber}
                            disabled
                            name="phoneNumber"
                            onChange={this.handleChange}
                            variant="standard"
                            color="primary"
                            helperText={errors.phoneNumber}
                          ></TextField>
                        </div>
                      </div>
                      <FormControl className="w-100 mt-3">
                        <FormGroup row className="formRemember">
                          <FormControlLabel
                            className="mx-0 mb-0"
                            control={
                              <Switch
                                checked={edit}
                                onChange={(e) =>
                                  this.setState({ edit: e.target.checked })
                                }
                                name="edit"
                              />
                            }
                            label="Edit"
                          />
                          <Button
                            size="small"
                            className="my-2"
                            variant="contained"
                            type="submit"
                            disabled={!edit}
                          >
                            Update
                          </Button>
                        </FormGroup>
                      </FormControl>
                    </form>
                  </div>
                </div>
              </section>
              <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                open={notification}
                onClose={() => {
                  this.setState({ notification: false });
                }}
                message="Successfully updated profile."
                autoHideDuration={2000}
              />
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Profile;
